import PositionDto from '@/models/Positions/PositionDto';
import DistanceViewModel from '@/models/Shared/DistanceViewModel';
import ListUtils from '@/lib/listUtils';
import ContactStatusViewModel from '@/models/Contacts/ContactStatusViewModel';
import ContactStatus from '@/models/Contacts/ContactStatus';
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import ContactProfileDto from '@/models/Contacts/ContactProfileDto';

export default class ContactSearchViewModel {
    statuses: ContactStatusViewModel[] = ListUtils.contactStatuses();
    selectedStatus: ContactStatus = ContactStatus.Active;
    selectedPositions: PositionDto[] = [];
    selectedLocationTypes: LocationTypeDto[] = [];
    workers: WorkerProfileDto[] = [];
    selectedWorker: WorkerProfileDto = null;
    selectedDistance: DistanceViewModel = new DistanceViewModel(20, "20");
    isAgreedToMarketing = true;
    selectedContacts: ContactProfileDto[] = [];
}